export function roundVal(val, decimalPlaces=2) {
  const factorOfTen = Math.pow(10, decimalPlaces);
  return Math.round((val+ Number.EPSILON)  * factorOfTen) / factorOfTen;
}
